import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';
import { OptionsComponent } from './options/options.component';
import { BrandingComponent } from './branding/branding.component';
import { TitlesComponent } from './titles/titles.component';
import { CustomQuestionComponent } from '../../manage-settings/custom-question/custom-question.component';
import { LmsSettingsComponent } from '../../manage-settings/lms-settings/lms-settings.component';
import { ReportLabelsComponent } from '../../manage-settings/report-labels/report-labels.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    NzTabsModule,
    NzButtonModule,
    OptionsComponent,
    BrandingComponent,
    TitlesComponent,
    CommonModule,
    CustomQuestionComponent,
    LmsSettingsComponent,
    ReportLabelsComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {
  selectedTabIndex = 0;
  @ViewChild(TitlesComponent) titleComponent!: TitlesComponent;
  @ViewChild('extraTemplate') extraTemplate!: TemplateRef<void>;

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  addNewTitle() {
    this.titleComponent.addTitle();
  }
}
